import { GSError } from '@gridscale/gsclient-js';
import { createAction, props } from '@ngrx/store';
import { FeatureFlagsTemplate } from './../../../app/@shared/models/featureFlags';

export const actionPrefix = '[featureFlags]';

export const loadFeatureFlags = createAction(actionPrefix + ' Load Feature Flags');
export const loadFeatureFlagsSuccess = createAction(actionPrefix + ' Load Feature Flags Success', props<{ featureFlags: FeatureFlagsTemplate[] }>());
export const loadFeatureFlagsFailure = createAction(actionPrefix + ' Load Feature Flags Failure', props<{ error: GSError }>());

export const loadDefaultFeatureFlagsSuccess = createAction(actionPrefix + ' Load Default Feature Flags Success', props<{ featureFlags: Partial<FeatureFlagsTemplate> }>());
export const loadDefaultFeatureFlagsFailure = createAction(actionPrefix + ' Load Default Feature Flags Failure', props<{ error: GSError }>());

export const patchFeatureFlags = createAction(actionPrefix + ' Patch Feature Flags', props<{ data: Record<string, boolean | null>; feature_flag_template_uuid: string }>());
export const patchFeatureFlagsSuccess = createAction(actionPrefix + ' Patch Feature Flags Success', props<{ feature_flag_template_uuid: string }>());
export const patchFeatureFlagsFailure = createAction(actionPrefix + ' Patch Feature Flags Failure', props<{ error: GSError }>());
